import * as BusEvents from "@/constants/bus-events";
import * as CustomChargeTypes from "../constants/custom-charge-types";
import * as Getters from "../store/constants/getters";

export default {
    data() {
        return {
            loadingShipping: false,
            shipping_rate: null,
            orderForm: new window.Form({
                card_token: null,
                use_existing: false,
                save_card: true,
                shipping_address_id: null,
                billing_address_id: null,
                different_shipping: false,
                billing_same_as_shipping: true,
                shipping_rate_id: null,
                notes: null,
                rush_processing: false,
                custom_shipping: false,
                custom_shipping_provider: null,
                custom_shipping_account_number: null,
                payment_type: null,
                po_number: null,
                coupon: null
            }),
            subscription_charge: {
                subscription_interval: null,
                subscription_amount: null
            }
        };
    },
    created() {
        this.getSubscriptionCharge();
        Bus.$on(BusEvents.CART_UPDATED, this.getSubscriptionCharge);
    },
    destroyed() {
        Bus.$off(BusEvents.CART_UPDATED, this.getSubscriptionCharge);
    },
    computed: {
        //where NOT community/corporation has_ups_account
        requiresShippingRate() {
            return this.$store.getters[Getters.REQUIRES_SHIPPING_RATE];
        },
        canCheckout() {
            return !!this.$store.state.cart.orders.length;
        },
        rushProcessingFee() {
            return this.$store.state.options.rush_processing_fee;
        },
        discountRate() {
            return _.get(
                this.$store.state.current_community,
                "corporation.discount_rate",
                0
            );
        },
        cartEditable() {
            return _.get(this.$store.state.cart, "editable", false);
        },
        lateFee() {
            return _.get(
                this.$store.state.current_community,
                "corporation.late_fee",
                false
            );
        },
        lateFeeAmount() {
            return _.get(
                this.$store.state.current_community,
                "corporation.late_fee_amount",
                0
            );
        },
        productTotal() {
            return _.sumBy(this.orders, (item) => {
                let digital_files_amount = _.sumBy(
                    item.digital_files,
                    (file) => {
                        return file.price;
                    }
                );
                let newsletter_photo_amount = this.newsletterPhotoAmount;
                if (item.calendar) {
                    let calendar_amount = _.sumBy(item.sizes, "amount");
                    let printed_extras_amount = _.sumBy(
                        item.printed_extras,
                        (extra) => {
                            return extra.price * extra.quantity;
                        }
                    );
                    let birthday_poster_amount = _.sumBy(
                        item.birthday_posters,
                        (poster) => {
                            return poster.price;
                        }
                    );
                    return (
                        calendar_amount +
                        digital_files_amount +
                        printed_extras_amount +
                        birthday_poster_amount
                    );
                } else {
                    let news_printed_extras_amount = _.sumBy(
                        item.printed_extras,
                        (extra) => {
                            return extra.price * extra.quantity;
                        }
                    );
                    let news_birthday_poster_amount = _.sumBy(
                        item.birthday_posters,
                        (poster) => {
                            return poster.price;
                        }
                    );
                    if (
                        this.$store.state.current_community
                            .newsletter_type_id == 4
                    ) {
                        newsletter_photo_amount =
                            this.newsletterPhotoCount <= 5
                                ? 0
                                : (this.newsletterPhotoAmount /
                                      this.newsletterPhotoCount) *
                                  (this.newsletterPhotoCount - 5);
                    }
                    return (
                        item.amount +
                        digital_files_amount +
                        newsletter_photo_amount +
                        this.newsletterPhotoPageAmount +
                        news_printed_extras_amount +
                        news_birthday_poster_amount
                    );
                }
            });
        },
        newsletterPhotoCount() {
            return this.$store.state.cart.newsletter_photo_count;
        },
        newsletterPhotoAmount() {
            return this.$store.state.cart.newsletter_photo_amount;
        },
        newsletterPhotoPageAmount() {
            return this.$store.state.cart.photo_page_amount;
        },
        newsletterPhotoPageCount() {
            return this.$store.state.cart.photo_page_count;
        },
        cartTotals() {
            let totals = [];
            let discount = 0;
            let rush_processing_fee = 0;
            let printed_items_amount = 0;
            let tax = 0;
            let cart_shipping_charge = _.get(
                this.shipping_rate,
                "charge",
                null
            );
            let cart_handling_charge = _.get(
                this.handling_charge,
                "charge",
                null
            );
            let coupon_shipping_discount = 0;
            let coupon_subscription_discount = 0;
            let newsletter_amount = 0;
            let date = moment();
            let day = parseInt(date.format("DD"));

            let cart_total = _.sumBy(this.orders, (item) => {
                let digital_files_amount = _.sumBy(
                    item.digital_files,
                    (file) => {
                        return file.price;
                    }
                );
                if (item.calendar) {
                    let calendar_amount = _.sumBy(item.sizes, "amount");
                    let printed_extras_amount = _.sumBy(
                        item.printed_extras,
                        (extra) => {
                            return extra.price * extra.quantity;
                        }
                    );
                    let birthday_posters_amount = _.sumBy(
                        item.birthday_posters,
                        (poster) => {
                            return poster.price;
                        }
                    );
                    printed_items_amount +=
                        calendar_amount +
                        printed_extras_amount +
                        birthday_posters_amount;
                    return (
                        calendar_amount +
                        digital_files_amount +
                        printed_extras_amount +
                        birthday_posters_amount
                    );
                } else {
                    let news_printed_extras_amount = _.sumBy(
                        item.printed_extras,
                        (extra) => {
                            return extra.price * extra.quantity;
                        }
                    );
                    let news_birthday_posters_amount = _.sumBy(
                        item.birthday_posters,
                        (poster) => {
                            return poster.price;
                        }
                    );
                    printed_items_amount +=
                        item.amount +
                        news_printed_extras_amount +
                        news_birthday_posters_amount;
                    newsletter_amount += item.amount;
                    return (
                        news_printed_extras_amount +
                        news_birthday_posters_amount +
                        item.amount +
                        digital_files_amount
                    );
                }
            });
            if (this.subscription_charge.subscription_interval) {
                totals.push({
                    label:
                        (this.subscription_charge.subscription_interval === 1
                            ? "Monthly"
                            : "Yearly") + " Subscription",
                    amount: this.subscription_charge.subscription_amount
                });
                cart_total += this.subscription_charge.subscription_amount;
            }
            if (
                this.$store.state.active_coupon &&
                this.subscription_charge.subscription_interval
            ) {
                for (
                    var i = 0;
                    i < this.$store.state.active_coupon.types.data.length;
                    i++
                ) {
                    if (
                        this.$store.state.active_coupon.types.data[i].name ==
                        "Free Subscription"
                    ) {
                        coupon_subscription_discount =
                            this.subscription_charge.subscription_amount;
                        totals.push({
                            label:
                                "Subscription Coupon: " +
                                this.$store.state.active_coupon.code,
                            amount: coupon_subscription_discount,
                            remove_coupon: true,
                            subtract: true
                        });
                    }
                }
            }

            if (this.$store.state.current_community.newsletter_type_id == 4) {
                cart_total +=
                    this.newsletterPhotoCount <= 5
                        ? 0
                        : (this.newsletterPhotoAmount /
                              this.newsletterPhotoCount) *
                          (this.newsletterPhotoCount - 5);
            } else {
                cart_total += this.newsletterPhotoAmount;
            }
            cart_total += this.newsletterPhotoPageAmount;
            totals.push({
                label: "Cart Total",
                bold: true,
                amount: cart_total - coupon_subscription_discount
            });
            //client has own shipping account
            if (!this.customShipping) {
                //console.log("shipping_rate", this.shipping_rate);
                totals.push({
                    label: "Shipping",
                    loading: this.loadingShipping,
                    amount: cart_shipping_charge
                });
            }

            //separate handling charge is added if custom shipping is enabled
            if (this.customShipping) {
                //console.log("handling_charge", this.handling_charge);
                totals.push({
                    label: "Handling",
                    loading: this.loadingShipping,
                    amount: cart_handling_charge
                });
            }

            if (this.$store.state.active_coupon) {
                for (
                    var i = 0;
                    i < this.$store.state.active_coupon.types.data.length;
                    i++
                ) {
                    if (
                        this.$store.state.active_coupon.types.data[i].name ==
                        "Free Shipping"
                    ) {
                        coupon_shipping_discount = cart_shipping_charge;
                        totals.push({
                            label:
                                "Shipping Coupon: " +
                                this.$store.state.active_coupon.code,
                            loading: this.loadingShipping,
                            amount: coupon_shipping_discount,
                            remove_coupon: true,
                            subtract: true
                        });
                    }
                }
            }
            if (this.orderForm.rush_processing) {
                rush_processing_fee = this.rushProcessingFee;
                totals.push({
                    label: "Rush Processing Fee",
                    amount: rush_processing_fee
                });
            }
            let custom_charge_total = 0;
            this.$store.state.current_community.custom_charges.data.forEach(
                (charge) => {
                    let orig_amount =
                        charge.type === CustomChargeTypes.AMOUNT
                            ? charge.value
                            : printed_items_amount * charge.value;
                    custom_charge_total += Utils.round(
                        (charge.type === CustomChargeTypes.PERCENTAGE
                            ? -1
                            : 1) * orig_amount
                    );
                    let amount = Math.abs(orig_amount);
                    totals.push({
                        label: charge.name,
                        amount,
                        subtract:
                            charge.value < 0 ||
                            charge.type === CustomChargeTypes.PERCENTAGE
                    });
                }
            );
            let late_fee_amount = 0;
            let cartMonth = moment(this.cartMonth.format("YYYY-MM-05"));
            let days_diff = moment().diff(cartMonth, "days");
            if (this.lateFee && days_diff > 0) {
                late_fee_amount = this.lateFeeAmount;
                totals.push({
                    label: "Late Fee",
                    amount: late_fee_amount
                });
            }
            if (this.discountRate > 0) {
                totals.push({
                    label: `Discount (${this.discountRate * 100}%)`,
                    amount: (discount = Utils.round(
                        printed_items_amount * this.discountRate
                    )),
                    subtract: true
                });
            }
            let subtotal;
            subtotal = Utils.round(
                rush_processing_fee +
                    cart_total +
                    custom_charge_total -
                    discount -
                    coupon_shipping_discount -
                    coupon_subscription_discount +
                    late_fee_amount
            );
            if (this.customShipping) {
                subtotal += cart_handling_charge;
            } else {
                subtotal += cart_shipping_charge;
            }
            totals.push({
                label: "Subtotal",
                amount: subtotal
            });
            if (
                !this.$store.state.current_community.tax_exempt &&
                this.$store.state.cart_tax
            ) {
                let taxable = subtotal;
                if (!this.$store.state.cart_tax.shipping_taxable) {
                    taxable -= cart_shipping_charge;
                }
                if (this.$store.state.cart_tax.rate) {
                    tax = Utils.round(
                        this.$store.state.cart_tax.rate * taxable
                    );
                }
                totals.push({
                    label: "Sales Tax",
                    amount: tax
                });
            }
            totals.push({
                label: "Grand Total",
                bold: true,
                amount: Utils.round(subtotal + tax)
            });
            return totals;
        },
        cartGrandTotal() {
            return _.get(
                _.find(this.cartTotals, { label: "Grand Total" }),
                "amount"
            );
        },
        missingLocations() {
            if (!this.$store.getters.calendarEnabled) {
                return false;
            }
            let locations = this.$store.state.current_community.locations.data;
            let cart = this.$store.state.cart;
            return _.filter(locations, (location) => {
                let existing = cart.orders.find((item) => {
                    return item.community_location_id === location.id;
                });
                return !existing;
            });
        },
        missingLocationsMessage() {
            let multiple = this.missingLocations.length > 1;
            return (
                `Calendar${multiple ? "s" : ""} required for location${
                    multiple ? "s" : ""
                }: ` + _.map(this.missingLocations, "name").join(", ")
            );
        },
        hasMissingCalendar() {
            return this.missingLocations.length > 0;
        },
        hasMissingNewsletter() {
            if (!this.$store.getters.newsletterEnabled) {
                return false;
            }
            let cart = this.$store.state.cart;
            return !cart.orders.find((item) => {
                return !!item.newsletter_id;
            });
        },
        missingNewsletterMessage() {
            return `Newsletter is required.`;
        },
        cartMonth() {
            if (!this.$store.state.cart.orders.length) {
                return this.$store.getters[Getters.CURRENT_MONTH];
            }
            let order = this.$store.state.cart.orders[0];
            let orderable = _.get(
                order,
                "calendar",
                _.get(order, "newsletter")
            );
            return moment({ year: orderable.year, month: orderable.month - 1 });
        },
        loadingTax() {
            return this.$store.state.loading_cart_tax;
        },
        requiresNewsletterPdfProof() {
            return _.get(
                this.$store.state.current_community,
                "corporation.requires_newsletter_sign_off",
                false
            );
        },
        limitPosters() {
            return _.get(
                this.$store.state.current_community,
                "corporation.limit_posters",
                false
            );
        },
        limitFlats() {
            return _.get(
                this.$store.state.current_community,
                "corporation.limit_flats",
                false
            );
        },
        coloredOnly() {
            return _.get(
                this.$store.state.current_community,
                "corporation.colored_only",
                false
            );
        }
    },
    methods: {
        isAddedToCart({
            size,
            digital_file,
            printed_extra,
            color_type,
            calendar_id,
            newsletter_id
        }) {
            let added = false;
            _.forEach(this.$store.state.cart.orders, (order_item) => {
                if (
                    order_item.calendar_id !== calendar_id ||
                    order_item.newsletter_id !== newsletter_id
                ) {
                    return;
                }
                if (size) {
                    _.forEach(order_item.sizes, (order_item_size) => {
                        if (
                            (added =
                                order_item_size.id === size.id &&
                                color_type === order_item_size.color_type)
                        ) {
                            return false;
                        }
                    });
                }
                if (digital_file) {
                    _.forEach(order_item.digital_files, (file) => {
                        if ((added = file.id === digital_file.id)) {
                            return false;
                        }
                    });
                }
                if (printed_extra) {
                    _.forEach(order_item.printed_extras, (extra) => {
                        if ((added = extra.id === printed_extra.id)) {
                            return false;
                        }
                    });
                }
                if (added) {
                    return false;
                }
            });
            return added;
        },
        getSubscriptionCharge() {
            if (!this.cartMonth) {
                return;
            }
            axios
                .get(`/web-api/cart/subscription`, {
                    params: {
                        year: this.cartMonth.year(),
                        month: this.cartMonth.month() + 1
                    }
                })
                .then((response) => {
                    this.subscription_charge = response.data;
                });
        }
    }
};
